import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import Select from 'react-select';
import LoadingOverlay from 'react-loading-overlay';
import { toast } from 'react-toastify';
import { Button } from 'reactstrap';

import { getAllClients, getClientFPs, saveClientFPs } from '../../../../state/services/clientService';
import { verifyToken, cleanRedirectState } from '../../../../state/services/authService';
import { getAllFPs } from '../../../../state/services/fpService';

class ClientFP extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            selectedClient: null,
            selectedFP: null,
            clientFPs: [],
            showActiveOnly:false
        };
    }

    static propTypes = {
        verifyToken: PropTypes.func.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        redirect: PropTypes.bool.isRequired,
        cleanRedirectState: PropTypes.func.isRequired,
        getAllClients: PropTypes.func.isRequired,
        getAllFPs: PropTypes.func.isRequired,
        getClientFPs: PropTypes.func.isRequired,
        saveClientFPs: PropTypes.func.isRequired,

        // Costants
        clients: PropTypes.array.isRequired,
        fps: PropTypes.array.isRequired,
        clientFPs: PropTypes.array,
        urlAdminHome: PropTypes.string.isRequired,
    };

    componentDidMount() {
        const token = localStorage.getItem('token');

        if (token && token.length > 0) {
            this.props.verifyToken();
        } else {
            localStorage.setItem('isLoggedIn', 'false');
            this.props.cleanRedirectState();
            this.props.history.push('/admin/');
        }

        this.props.getAllClients();
        this.props.getAllFPs();
        this.setState({ loading: true });
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        const { redirect, clients, clientFPs } = newProps;
        const currentRoute = this.props.location.pathname;
        if (redirect && currentRoute != '/') {
            localStorage.setItem('isLoggedIn', 'false');
            this.props.cleanRedirectState();
            this.props.history.push('/admin');
        }

        if (clients && clients.length > 0) {
            this.setState({ loading: false });
        }

        if (this.props.clientFPs !== clientFPs && clientFPs) {
            this.setState({ loading: false, clientFPs });
        }
    }

    notify = (text) => {
        toast(text);
    };

    displayNoOptionsMessage() {
        return;
    }

    handleChangeActiveOnly = (e) => {
        this.setState({ showActiveOnly: e.target.checked });
    }

    handleChangeSelect(e, src, id = -1) {
        if (id !== -1) {
            const { clients, fps } = this.props;
            const { clientFPs, selectedFP, selectedClient } = this.state;
            const objIndex = clientFPs.findIndex(clientFP => clientFP.id === id);
            // Check existance
            let fp, client, filteredClientFP;
            if (src === 'fp') {
                fp = fps.find(_fp => _fp.fp_company_name === e.value);
                const clientObj = clients.find(_client => _client.company_name == selectedClient);
                filteredClientFP = clientFPs
                    .find(_clientFP => clientObj.pk_id_dme_client === _clientFP.client && fp.id === _clientFP.fp);
                
                if (filteredClientFP) {
                    this.notify(`${selectedClient} + ${e.value} rule does already exist.`);
                    return;
                }

                clientFPs[objIndex][src] = fp.id;
            } else if (src === 'client') {
                client = clients.find(_client => _client.company_name === e.value);
                const fpObj = fps.find(_fp => _fp.fp_company_name == selectedFP);
                filteredClientFP = clientFPs
                    .find(_clientFP => client.pk_id_dme_client === _clientFP.client && fpObj.id === _clientFP.fp);
                
                if (filteredClientFP) {
                    this.notify(`${e.value} + ${selectedFP} rule does already exist.`);
                    return;
                }

                clientFPs[objIndex][src] = client.pk_id_dme_client;
            }

            this.setState({ clientFPs });
        } else {
            if (src === 'client') {
                this.setState({ selectedClient: e.value });
            } else if (src === 'fp') {
                this.setState({ selectedFP: e.value });
            }
        }
    }

    onClickFind(e) {
        e.preventDefault();

        const { selectedClient, selectedFP } = this.state;
        const { clients, fps } = this.props;

        if (!selectedClient && !selectedFP) {
            this.notify('Please selected one of Client or FP');
            return;
        }

        const client = clients.find(client => client.company_name == selectedClient);
        const fp = fps.find(fp => fp.fp_company_name === selectedFP);

        this.props.getClientFPs(client, fp);
        this.setState({ loading: true });
    }

    onClickReset(e) {
        e.preventDefault();
        this.setState({ selectedClient: null, selectedFP: null });
    }

    onClickNew(e) {
        e.preventDefault();
        const { clients, fps } = this.props;
        const { selectedFP, selectedClient } = this.state;
        if (!selectedClient && !selectedFP) {
            this.notify('Please selected one of Client or FP');
            return;
        }

        const client = clients.find(client => client.company_name == selectedClient);
        const fp = fps.find(fp => fp.fp_company_name === selectedFP);
        const clientValue = client ? client.pk_id_dme_client : null;
        const fpValue = fp ? fp.id : null;
        const clientFPs = [{
            'id': null,
            'client': clientValue,
            'fp': fpValue,
            'price_throttle_min': 0,
            'price_throttle_max': 0,
            'is_active': true,
        }];
        this.setState({ clientFPs });
    }

    onClickSave(e) {
        e.preventDefault();
        const { clientFPs } = this.state;

        // Validation
        for (let clientFP of clientFPs) {
            if (clientFP['client'] === null || clientFP['fp'] === null) {
                this.notify('Please populate all the client and fp');
                return;
            }

            if (clientFP['price_throttle_min'] < 0 ||
                clientFP['price_throttle_min'] > 100 ||
                clientFP['price_throttle_max'] < 0 ||
                clientFP['price_throttle_max'] > 100
            ) {
                this.notify('Price throttle values should be in 0 ~ 1');
                return;
            }

            if (clientFP['price_throttle_min'] > clientFP['price_throttle_max']) {
                let temp = clientFP['price_throttle_min'];
                clientFP['price_throttle_min'] = clientFP['price_throttle_max'];
                clientFP['price_throttle_max'] = temp;
            }
        }

        this.props.saveClientFPs(clientFPs);
        this.setState({ loading: true });
    }

    onInputChange(event, id, src) {
        event.preventDefault();
        const { clientFPs } = this.state;
        const index = clientFPs.findIndex(_clientFP => _clientFP.id === id);
        clientFPs[index][src] = parseFloat(event.target.value);
        this.setState({ clientFPs });
    }

    onToggleActive(id) {
        const { clientFPs } = this.state;
        const objIndex = clientFPs.findIndex(clientFP => clientFP.id === id);
        clientFPs[objIndex]['is_active'] = !clientFPs[objIndex]['is_active'];
        this.setState({ clientFPs });
    }

    render() {
        const { clients, fps } = this.props;
        const { loading, selectedClient, selectedFP, clientFPs } = this.state;

        const clientOptions = clients
            .map(client => ({value: client.company_name, label: client.company_name}))
            .sort((a,b) => a.label.localeCompare(b.label));
        const currentClientOption = {value: selectedClient, label: selectedClient};
        const fpOptions = fps
            .map(fp => ({value: fp.fp_company_name, label: fp.fp_company_name}));
        const currentFPOption = {value: selectedFP, label: selectedFP};

        const sorted = [...clientFPs];
        sorted.sort((clientFPA, clientFPB) => {
            if(clientFPA.id === null) return true;
            if(clientFPB.id === null) return false;
            let clientA, fpA;
            let clientB, fpB;
            if (clientFPA['client'] !== null) {
                clientA = clients.find(_client => _client.pk_id_dme_client == clientFPA.client);
            }
            if (clientFPA['fp'] !== null) {
                fpA = fps.find(_fp => _fp.id == clientFPA.fp);
            }
            
            if (clientFPB['client'] !== null) {
                clientB = clients.find(_client => _client.pk_id_dme_client == clientFPB.client);
            }
            if (clientFPB['fp'] !== null) {
                fpB = fps.find(_fp => _fp.id == clientFPB.fp);
            }
            // console.log(clientA.company_name, clientB.company_name, clientA.company_name === clientB.company_name ? (fpA.fp_company_name > fpB.fp_company_name) : (clientA.company_name > clientB.company_name));
            return clientA.company_name === clientB.company_name ? fpA.fp_company_name.localeCompare(fpB.fp_company_name) : clientA.company_name.localeCompare(clientB.company_name);
        });
        
        const filtered = sorted.filter(clientFP => {
            return this.state.showActiveOnly ? clientFP['is_active'] : true;
        });

        const clientFPList = filtered.map((clientFP, index) => {
            let client, fp, clientSelectVal, fpSelectVal;
            clientSelectVal = {value: null, label: null};
            fpSelectVal = {value: null, label: null};
            if (clientFP['client'] !== null) {
                client = clients.find(_client => _client.pk_id_dme_client == clientFP.client);
                clientSelectVal = {value: client.company_name, label: client.company_name};
            }
            if (clientFP['fp'] !== null) {
                fp = fps.find(_fp => _fp.id == clientFP.fp);
                fpSelectVal = {value: fp.fp_company_name, label: fp.fp_company_name};
            }

            return (
                <tr key={clientFP.id}>
                    <td>{index + 1}</td>
                    <td>{(clientFP['id'] && clientFP['client']) ?
                        client.company_name
                        :
                        <Select
                            value={clientSelectVal}
                            onChange={(e) => this.handleChangeSelect(e, 'client', clientFP.id)}
                            options={clientOptions}
                            placeholder='Select a Client'
                            noOptionsMessage={() => this.displayNoOptionsMessage()}
                            isDisabled={selectedClient !== null}
                        />
                    }</td>
                    <td>{(clientFP['id'] && clientFP['fp']) ?
                        fp.fp_company_name
                        :
                        <Select
                            value={fpSelectVal}
                            onChange={(e) => this.handleChangeSelect(e, 'fp', clientFP.id)}
                            options={fpOptions}
                            placeholder='Select a FP'
                            noOptionsMessage={() => this.displayNoOptionsMessage()}
                            isDisabled={selectedFP !== null}
                        />
                    }</td>
                    <td>
                        <input
                            type="number"
                            className="form-control"
                            placeholder="Price Throttle Min (0 ~ 100)"
                            value={clientFP.price_throttle_min}
                            onChange={(e) => this.onInputChange(e, clientFP.id, 'price_throttle_min')}
                            step="1"
                            min="0"
                            max="100"
                        />
                    </td>
                    <td>
                        <input
                            type="number"
                            className="form-control"
                            placeholder="Price Throttle Max (0 ~ 100)"
                            value={clientFP.price_throttle_max}
                            onChange={(e) => this.onInputChange(e, clientFP.id, 'price_throttle_max')}
                            step="1"
                            min="0"
                            max="100"
                        />
                    </td>
                    <td>
                        <input
                            type='checkbox'
                            color='primary'
                            checked={clientFP['is_active'] ? true : false}
                            onClick={() => this.onToggleActive(clientFP.id)}
                        />
                    </td>
                </tr>
            );
        });

        return (
            <div className="client-fp">
                <div className="pageheader">
                    <h1>Client + FP management page</h1>
                    <div className="breadcrumb-wrapper hidden-xs">
                        <span className="label">You are here:</span>
                        <ol className="breadcrumb">
                            <li><a href={this.props.urlAdminHome}>Home</a></li>
                            <li><a href="/admin/client-fp">Client + FP</a></li>
                            <li className="active">List</li>
                        </ol>
                    </div>
                </div>

                <section id="main-content" className="animated fadeInUp">
                    <LoadingOverlay
                        active={loading}
                        spinner
                        text='Loading...'
                    >
                        <form onSubmit={(e) => this.onClickFind(e)} role="form" className="container">
                            <div className="row">
                                <div className="form-group col-md-4">
                                    <label htmlFor="clients">Clients: </label>
                                    <Select
                                        value={currentClientOption}
                                        onChange={(e) => this.handleChangeSelect(e, 'client', -1)}
                                        options={clientOptions}
                                        placeholder='Select a Client'
                                        noOptionsMessage={() => this.displayNoOptionsMessage()}
                                    />
                                </div>
                                <div className="form-group col-md-4">
                                    <label htmlFor="fps">Freight Providers:</label>
                                    <Select
                                        value={currentFPOption}
                                        onChange={(e) => this.handleChangeSelect(e, 'fp', -1)}
                                        options={fpOptions}
                                        placeholder='Select a FP'
                                        noOptionsMessage={() => this.displayNoOptionsMessage()}
                                    />
                                </div>
                                <div className="form-group actions col-md-4 d-flex justify-content-center align-items-center py-4">
                                    <Button type="submit" color="primary">Find</Button>
                                    <Button color="danger" onClick={(e) => this.onClickReset(e)}>Reset</Button>
                                    <Button
                                        color="success"
                                        onClick={(e) => this.onClickNew(e)}
                                        disabled={selectedFP && selectedClient}
                                    >New</Button>
                                    <Button
                                        color="info"
                                        onClick={(e) => this.onClickSave(e)}
                                        disabled={clientFPs.length === 0}
                                    >Save</Button>
                                </div>
                            </div>
                        </form>

                        <div className='list container'>
                            <div className='d-flex mt-2 justify-content-end align-items-center py-2'>
                                <label className="mr-2">Show Active Only</label>
                                <input type="checkbox" checked={this.state.showActiveOnly} onChange={this.handleChangeActiveOnly}/>
                            </div>
                            {((selectedFP || selectedClient) && clientFPs.length == 0) ?
                                <strong>No results</strong>
                                :
                                <table className="table table-hover table-bordered sortable fixed_headers">
                                    <thead>
                                        <tr>
                                            <th>No</th>
                                            <th>Client</th>
                                            <th>FP</th>
                                            <th>Price Throttle Min</th>
                                            <th>Price Throttle Max</th>
                                            <th>Is Active?</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        { clientFPList }
                                    </tbody>
                                </table>
                            }
                        </div>
                    </LoadingOverlay>
                </section>

                
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        redirect: state.auth.redirect,
        urlAdminHome: state.url.urlAdminHome,
        username: state.auth.username,
        clients: state.client.clients,
        fps: state.fp.allFPs,
        clientFPs: state.client.clientFPs,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        verifyToken: () => dispatch(verifyToken()),
        cleanRedirectState: () => dispatch(cleanRedirectState()),
        getAllClients: () => dispatch(getAllClients()),
        getAllFPs: () => dispatch(getAllFPs()),
        getClientFPs: (client, fp) => dispatch(getClientFPs(client, fp)),
        saveClientFPs: (clientFPs) => dispatch(saveClientFPs(clientFPs)),
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ClientFP));



// WEBPACK FOOTER //
// ./src/pages/admin/AdminViews/ClientFP/ClientFP.js